import { render, staticRenderFns } from "./triangleCorner.vue?vue&type=template&id=7a059d9d&scoped=true&"
import script from "./triangleCorner.vue?vue&type=script&lang=js&"
export * from "./triangleCorner.vue?vue&type=script&lang=js&"
import style0 from "./triangleCorner.vue?vue&type=style&index=0&id=7a059d9d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a059d9d",
  null
  
)

export default component.exports